export const REASONS = [
  'Personality mismatch',
  'Personal preference',
  'Instruction quality',
  'Instructor attendance issues',
  'Instructor technical issues',
  'No reason',
]
export const THIS_COURSE = 'This course'
export const THIS_COURSE_AND_ALL_FUTURE_COURSES = 'This course and all future courses'
export const BLOCK_FOR = [THIS_COURSE, THIS_COURSE_AND_ALL_FUTURE_COURSES]
